export default __webpack_public_path__ + "img/sagoo/sagoo10_src.jpg";